import { RouterProvider } from 'react-router-dom';

import { ApolloProvider } from '@apollo/client';
import { Authenticator } from '@aws-amplify/ui-react';
import CssBaseline from '@mui/material/CssBaseline';
import { registerLicense } from '@syncfusion/ej2-base';
import { Amplify } from 'aws-amplify';

import ErrorBoundary from './components/ErrorBoundary';
import PendoScriptInjector from './components/PendoScriptInjector';
import VersionUpdateBanner from './components/VersionUpdateBanner/VersionUpdateBanner';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { TenantProvider } from './contexts/TenantContext';
import { UserProvider } from './contexts/UserContext';
import { apolloClient } from './gql/clients';
import { awsExports } from './lib/aws-exports';
import { QueryProvider } from './providers/QueryProvider';
import { SnackbarProvider } from './providers/SnackbarProvider';
import Notifications from './services/Notifications';
import ThemeProvider from './theme/ThemeProvider';
import router from './routes';

registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE_KEY);

Amplify.configure(awsExports);

export function App() {
  return (
    <>
      <ErrorBoundary>
        <VersionUpdateBanner />
        <Authenticator.Provider>
          <PendoScriptInjector />
          <ThemeProvider>
            <TenantProvider>
              <ApolloProvider client={apolloClient}>
                <QueryProvider>
                  <UserProvider>
                    <SnackbarProvider>
                      <CssBaseline />
                      <NotificationsProvider>
                        <Notifications />
                        <RouterProvider router={router} />
                      </NotificationsProvider>
                    </SnackbarProvider>
                  </UserProvider>
                </QueryProvider>
              </ApolloProvider>
            </TenantProvider>
          </ThemeProvider>
        </Authenticator.Provider>
      </ErrorBoundary>
      <style>{`
        .sentry-feedback {
          display: none !important;
        }
      `}</style>
    </>
  );
}

export default App;
